import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Create from "./Create";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TablePagination,
  Slide,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditOffIcon from "@mui/icons-material/EditOff";
import FilterListIcon from "@mui/icons-material/FilterList";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HeaderTemplates() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);
  const [platformsearchitems, setPlatformsearchItems] = React.useState(0);
  const [standardsearchitems, setStandardsearchItems] = React.useState(0);
  const [state, setState] = React.useState({
    name: "",
    os_type: "",
    delete_id: "",
  });

  const [templateslist, settemplateslist] = React.useState([[]]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationtemplateslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          settemplateslist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const Delete = (userId) => {
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/del_temp/${userId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          window.top.location.reload(false);
        })
        .catch((error) => {
          console.log(error);
          window.location.reload();
        });
    };
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);

  function popup(userId) {
    window.localStorage.setItem("userId", userId);
    if (userId !== "") {
      toggle();
    }
  }
  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  function del(deleteid) {
    setState({ delete_id: deleteid });
  }
  function refreshPage() {
    window.location.reload();
  }

  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  const overallauditlengh = templateslist.length;

  const [temporarynumber, setTemporaryNumber] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [pageSize, setPageSize] = useState(20);

  const pageCount = Math.ceil(overallauditlengh / pageSize);

  useEffect(() => {
    if (overallauditlengh < 300) {
      const value = 20;
      setPageSize(value);
    } else if (overallauditlengh <= 500) {
      const value1 = 20 * 4;
      setPageSize(value1);
    } else if (overallauditlengh > 500 && pageCount < 650) {
      const value2 = 20 * 8;
      setPageSize(value2);
    } else {
      const value3 = 20 * 16;
      setPageSize(value3);
    }
  }, []);

  const handlePageClick = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
    if (currentPage === 0) {
      setTemporaryNumber(parseInt(temporarynumber) - parseInt(pageSize));
    } else {
      const pageAddValue = parseInt(pageSize) * parseInt(currentPage);
      setTemporaryNumber(parseInt(pageAddValue) + 1);
    }
  };

  const handleClicknextPage = () => {
    setCurrentPage(currentPage + 1);
    if (currentPage === 0) {
      setTemporaryNumber(parseInt(overallauditlengh) - parseInt(pageSize));
    } else {
      const pageAddValue = parseInt(pageSize) * parseInt(currentPage);
      setTemporaryNumber(parseInt(overallauditlengh) - parseInt(pageAddValue));
    }
  };

  const handleClickpreviousPage = () => {
    setCurrentPage(currentPage - 1);
    if (currentPage === 0) {
      setTemporaryNumber(parseInt(temporarynumber) + parseInt(pageSize));
    } else {
      const pageAddValue = parseInt(pageSize) * parseInt(currentPage);
      setTemporaryNumber(parseInt(overallauditlengh) + parseInt(pageAddValue));
    }
  };

  const handleClickfirstPage = () => {
    setCurrentPage(0);
    setTemporaryNumber(0);
  };

  const handleClicklastPage = () => {
    setCurrentPage(pageCount - 1);
    const pageAddValue = parseInt(pageSize) * parseInt(currentPage);
    setTemporaryNumber(parseInt(pageAddValue) + 1);
  };

  const handleClicksetPage = (e) => {
    setPageSize(e.target.value);
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle3 = () => setDropdownOpen((prevState) => !prevState);

  const [tempeditvalue, settempeditvalue] = React.useState([]);

  const handleEditClick = (e) => {
    e.preventDefault;
    const tempID = window.sessionStorage.getItem("TempID");
    fetch(`${process.env.REACT_APP_API_URL}/api/templates/${tempID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => settempeditvalue(resp))
      .catch((error) => {
        console.error(error);
      });

    window.location.href = "/admin/editprofile";
  };

  const unique = [
    ...new Set(
      templateslist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const cloumnName1 = "name";
  const cloumnName2 = "platform";
  const cloumnName3 = "compliance";

  const pagecreateRedirect = () => {
    window.location.href = "/admin/makeprofile";
  };
  const pageeditRedirect = () => {
    window.location.href = "/admin/editprofile";
  };

  const [platform, setplatform] = React.useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/generics/platform/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setplatform(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [filterapply, setFilterapply] = useState(false);
  const [filteropen, setFilteropen] = React.useState(false);

  const handleClickFilterOpen = () => {
    setFilterapply(true);
    setFilteropen(true);
  };

  const handleFilterClose = () => {
    setFilteropen(false);
  };

  const handleClickFilterApply = () => {
    setFilteropen(false);
  };

  const [platformcompliance, setPlatformcompliance] = React.useState([]);

  const handleClicksearchplatform = (e) => {
    e.preventDefault;
    setPlatformsearchItems(e.target.value);
    const platform = e.target.value;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationcompliance/${platform}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setPlatformcompliance(resp))
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClickFilterClear = () => {
    setPlatformsearchItems(0);
    setStandardsearchItems(0);
    setFilterapply(false);
    setFilteropen(false);
    setPlatformcompliance([]);
  };

  return (
    <>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          Delete Template
        </h2>
        <DialogContent style={{ overflowWrap: "anywhere" }}>
          <a style={{ fontSize: "smaller" }}>
            Are you sure you want to delete{" "}
          </a>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle2}
            size="sm"
          >
            Close
          </button>
          <button
            className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={Delete(state.delete_id)}
            size="sm"
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={filteropen}
        onClose={handleFilterClose}
      >
        <DialogTitle>Filter</DialogTitle>
        <DialogContent>
          <Typography variant="h7" gutterBottom component="div">
            Platform:
          </Typography>
          <div className="relative flex flex-wrap items-stretch ml-2">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>

            <input
              type="text"
              list="platforms"
              placeholder={
                platformsearchitems
                  ? platformsearchitems
                  : "Please choose the require Platform ..."
              }
              onChange={handleClicksearchplatform}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
            />
            <datalist id="platforms">
              {platform.map((val) => (
                <option>{val.title}</option>
              ))}
            </datalist>
          </div>
          <br />
          <Typography variant="h7" gutterBottom component="div">
            Compilance:
          </Typography>
          <div className="relative flex flex-wrap items-stretch ml-2">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>
            <input
              type="text"
              list="standards"
              disabled={
                platformsearchitems && platformcompliance.length > 0
                  ? false
                  : true
              }
              placeholder={
                standardsearchitems
                  ? standardsearchitems
                  : "Please choose the require Compliance ..."
              }
              onChange={(event) => {
                setStandardsearchItems(event.target.value);
              }}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
            />
            <datalist id="standards">
              {platformcompliance.length > 0 ? (
                <React.Fragment>
                  {platformcompliance.map((val) => (
                    <option>{val}</option>
                  ))}
                </React.Fragment>
              ) : (
                <option>Compilance Not Available</option>
              )}
            </datalist>
          </div>
        </DialogContent>
        <DialogActions>
          {platformsearchitems && standardsearchitems ? (
            <Button
              color="error"
              variant="outlined"
              onClick={handleClickFilterClear}
            >
              Clear
            </Button>
          ) : (
            ""
          )}
          <Button variant="outlined" onClick={handleFilterClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={platformsearchitems && standardsearchitems ? false : true}
            onClick={handleClickFilterApply}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <div className="col">
        <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
          <div className="relative flex flex-wrap items-stretch ml-2">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>
            <input
              type="text"
              placeholder="Search Name ..."
              onChange={(event) => {
                setSearchItems(event.target.value);
              }}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
            />
          </div>
        </form>
      </div>
      <br />
      <Card>
        <CardHeader
          action={
            <React.Fragment>
              <IconButton
                title="Filter"
                aria-label="Filter"
                id="filter"
                style={{ marginRight: "5px", color: "navy" }}
                variant="outlined"
                onClick={handleClickFilterOpen}
              >
                <FilterListIcon variant="outlined" />
              </IconButton>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
                onClick={pagecreateRedirect}
              >
                Add Profile
              </button>
            </React.Fragment>
          }
          title="PROFILE LIST"
        />
        <Paper sx={{ width: "100%" }}>
          <TableContainer sx={{ maxHeight: 1050 }}>
            <Table>
              <TableHead className="bg-lightBlue-200">
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="center">Name</TableCell>
                  <TableCell align="center">Platform</TableCell>
                  <TableCell align="center">compliance</TableCell>
                  {window.localStorage.getItem("audit_run_access") ===
                  "You do not have permission to perform this action." ? (
                    ""
                  ) : (
                    <React.Fragment>
                      <TableCell align="center">Edit</TableCell>
                      <TableCell align="center">Delete</TableCell>
                    </React.Fragment>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {unique
                  .filter((val) => {
                    if (filterapply) {
                      if (
                        platformsearchitems == "" ||
                        standardsearchitems == ""
                      ) {
                        return val;
                      } else if (
                        val[cloumnName2]
                          .toLowerCase()
                          .includes(platformsearchitems.toLowerCase()) &&
                        val[cloumnName3]
                          .toLowerCase()
                          .includes(standardsearchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    } else {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName1]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    }
                  })
                  .slice(page * limit, page * limit + limit)
                  .map((user2) => (
                    <TableRow>
                      <TableCell align="center">
                        {user2.serial_number}
                      </TableCell>
                      <TableCell align="center">{user2.name}</TableCell>
                      <TableCell align="center">{user2.platform}</TableCell>
                      <TableCell align="center">{user2.compliance}</TableCell>
                      {window.localStorage.getItem("audit_run_access") ===
                      "You do not have permission to perform this action." ? (
                        ""
                      ) : (
                        <React.Fragment>
                          <TableCell align="center">
                            <IconButton
                              title="Edit"
                              aria-label="edit"
                              id="edit"
                              style={{ padding: "0px", color: "#6b6f6b" }}
                              disabled={
                                user2.temp_type === "default" ? true : false
                              }
                            >
                              {user2.temp_type === "default" ? (
                                <EditOffIcon />
                              ) : (
                                <EditIcon
                                  fontSize="small"
                                  onClick={(e) => {
                                    window.sessionStorage.setItem(
                                      "platform",
                                      user2.platform
                                    );
                                    window.sessionStorage.setItem(
                                      "os_type",
                                      user2.os_type
                                    );
                                    window.sessionStorage.setItem(
                                      "compliance",
                                      user2.compliance
                                    );
                                    window.sessionStorage.setItem(
                                      "templatename",
                                      user2.name
                                    );
                                    window.sessionStorage.setItem(
                                      "TempID",
                                      user2.id
                                    );
                                    window.sessionStorage.setItem(
                                      "Audits",
                                      user2.selected_audits
                                    );
                                    handleEditClick(e);
                                  }}
                                />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              title="Delete"
                              aria-label="delete"
                              id="delete"
                              style={
                                user2.temp_type === "default"
                                  ? {
                                      padding: "0px",
                                    }
                                  : {
                                      padding: "0px",
                                      color: "#e68383",
                                    }
                              }
                              disabled={
                                user2.temp_type === "default" ? true : false
                              }
                            >
                              {user2.temp_type === "default" ? (
                                <DeleteForeverIcon />
                              ) : (
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() => {
                                    toggle2();
                                    window.sessionStorage.setItem(
                                      "templatename",
                                      user2.name
                                    );
                                    window.sessionStorage.setItem(
                                      "platform",
                                      user2.platform
                                    );
                                    del(user2.id);
                                  }}
                                />
                              )}
                            </IconButton>
                          </TableCell>
                        </React.Fragment>
                      )}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          component="div"
          count={templateslist.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Card>
    </>
  );
}